import { PURE, SUCCESS } from '@travel-frontend/state-handling-sdk';
import { DO_LOGIN, DO_LOGOUT, DO_REGISTER, FORGOT_PASSWORD } from '../../../../components/Authentication/redux/models.js';
import * as authEvents from '../../../../components/Authentication/redux/trackingEvents/events/index.js';
export const eventsMap = {
  [SUCCESS(DO_LOGIN)]: authEvents.loginEvent.handler,
  [SUCCESS(FORGOT_PASSWORD)]: authEvents.forgetPasswordEvent.handler,
  [SUCCESS(DO_REGISTER)]: authEvents.registerEvent.handler,
  [PURE(DO_LOGOUT)]: authEvents.logoutEvent.handler
};